module.exports = __webpack_public_path__ + "img/from_toeic_situation.6f790893.svg";